import React, { useState, useEffect, } from "react";
import { FormattedMessage, } from "react-intl";
import Spinner from "../../../components/Spinner";
import { StatusBadge, } from '../../../components/helpers';
import { useNavigate, } from 'react-router';
import Gravatar from 'react-gravatar';
import { Row, Card, Button, Col, Descriptions, Space, Avatar, } from 'antd';
import notification from '../../../services/notification';
import { EditUserModal, } from '../../../components/users';
import { UserDetails, } from '../../../services/users';
import { PenIcon, } from "@phosphor-icons/react";

const ProfileDetailView = ({
    ...props
}) => {

    const [userProfileData, setUserProfileData] = useState(undefined);
    const [detailsLoading, setDetailsLoading] = useState(true);
    const [editCustomerOpen, setEditCustomerOpen] = useState(false);

    const history = useNavigate();
    const customerID = "me";
    const localdata = sessionStorage.getItem('authentication');
    const LocalStore = JSON.parse(localdata || '{}');

    useEffect(() => {
        if (userProfileData) {
            setDetailsLoading(false);
        }
        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfileData]);

    useEffect(() => {
        loadProfileDetails();

        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadProfileDetails = () => {
        setDetailsLoading(true);

        // get the user profile details
        UserDetails({ user_id: customerID }, history)
            .then(response => {
                if (response.status) {
                    setUserProfileData(response.data);

                } else {
                    history('/dashboard');
                    console.error('error:', response)
                    notification['warning']({
                        message: 'User details',
                        description: "Error on requesting profile settings data",
                    });
                }
            })
            .catch(error => {
                console.error('error: ', error);
            });
    };


    return (
        <React.Fragment >

            <Row gutter={[32, 32]}>
                <Col span={24}>

                    {/* Status and availabilty banner */}
                    {/* <Card>
                        BANNNNEEEERRR
                    </Card> */}

                    {/* Profile basic card */}
                    {detailsLoading && (<Spinner />)}

                    {!detailsLoading && (
                        <Card
                            title={<h4 className="card-title"><FormattedMessage id="profile-user-details" /></h4>}
                            className="my-4"
                            // loading={detailsLoading}
                            extra={[
                                <Button
                                    key="1"
                                    // className="ant-btn-success"
                                    onClick={() => { setEditCustomerOpen(!editCustomerOpen) }}
                                    icon={<PenIcon size={16} weight="light" />}>
                                    <FormattedMessage id="profile-edit" />
                                </Button>,
                            ]}>

                            {/* user profile details */}
                            <Descriptions bordered column={1}>
                                <Descriptions.Item label={<FormattedMessage id="user-image" />}>
                                    <Space>
                                        <Avatar size="large" icon={<Gravatar email={LocalStore.user_email} default="robohash" className="rounded-full" />} />
                                    </Space>
                                </Descriptions.Item>
                                <Descriptions.Item label={<FormattedMessage id="user-status" />}><StatusBadge status={userProfileData?.user_status} /></Descriptions.Item>
                                <Descriptions.Item label={<FormattedMessage id="user-name" />}>{userProfileData?.user_data?.user_first_name} {userProfileData?.user_data?.user_last_name}</Descriptions.Item>
                                <Descriptions.Item label={<FormattedMessage id="emailaddress" />}>{userProfileData?.user_email}</Descriptions.Item>
                                <Descriptions.Item label={<FormattedMessage id="phonenumber" />}>{userProfileData?.user_data?.user_phone_number}</Descriptions.Item>
                                <Descriptions.Item label={<FormattedMessage id="display-language" />}>
                                    <FormattedMessage id={`language_${userProfileData?.user_data?.user_language}`} />
                                </Descriptions.Item>
                            </Descriptions>
                        </Card>
                    )}

                </Col>
            </Row>

            {editCustomerOpen && (
                <EditUserModal
                    modalIsOpen={editCustomerOpen}
                    modalIsOpenHandler={setEditCustomerOpen}
                    userProfileData={userProfileData}
                    refreshData={loadProfileDetails}
                    history={history}
                    {...props}
                />
            )}

        </React.Fragment>
    );
};

export default ProfileDetailView;